<template>
    <div>
        <v-select
            ref="vselect"
            :options="sortOptions"
            :filterable="false"
            v-bind="$attrs"
            :value="value"
            :searchable="true"
            @search="onSearch"
            @input="onChange"
            v-on="$listeners"
            @search:blur="setSearchText"
        >
            <template slot="no-options">
                <span v-if="search_text.length < 2">Type to search</span>
                <span v-else-if="!loading">No matches found</span>
                <span v-else></span>
            </template>
            <template v-if="showMenu" slot="header">
                <div class="menu">
                    <a
                        class="badge badge-success rounded-0"
                        @click.stop="addPaymentMethod"
                        >Add New</a
                    >
                    {{ search_text }}
                </div>
            </template>
        </v-select>
        <NewPaymentMethod
            ref="newPaymentMethodWindow"
            @saved="onChange"
        ></NewPaymentMethod>
    </div>
</template>
<script>
import vSelect from "vue-select";
import Fuse from "fuse.js";
import { debounce, get } from "lodash";
import NewPaymentMethod from "./payment_method/modal.vue";

export default {
    components: {
        vSelect,
        NewPaymentMethod
    },
    props: {
        module: {
            String,
            required: true,
            validator: function (value) {
                // The value must match one of these strings
                return ["payment-method"].indexOf(value) !== -1;
            }
        },
        payer: {
            type: Object,
            default() {}
        },
        isExtension: {
            type: Number,
            default: null
        },
        clientId: {
            type: String,
            default: null
        },
        entity: {
            required: true,
            type: String,
            default: null,
            validator: function (value) {
                return ["client", "business"].includes(value);
            }
        },
        ccProcessor: {
            type: String,
            default: null
        },
        value: {
            type: Object,
            default() {}
        },
        options: {
            type: Array,
            default: () => []
        },
        showMenu: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            search_text: "",
            remote_options: [],
            prefetch_options: [],
            txt: "",
            loading: false,
            subscription: {}
        };
    },
    computed: {
        sortOptions() {
            let self = this;
            let results = self.prefetch_options.length
                ? self.prefetch_options
                : self.remote_options.length
                ? self.remote_options
                : self.options.length
                ? self.options
                : [];
            if (self.search_text) {
                const searcher = new Fuse(results, {
                    shouldSort: true,
                    keys: ["label", "name", "email", "mobile", "work", "home"]
                });
                return searcher.search(self.search_text);
            } else {
                return results;
            }
        }
    },
    watch: {
        payer() {
            this.searchModule("", this);
        }
    },
    mounted() {
        if (this.module === "payment-method") {
            this.searchModule("", this);
        }
    },
    methods: {
        onSearch(search) {
            this.remote_options = [];
            this.search_text = search;
            if (search.length >= 2) {
                this.loading = true;
                this.searchModule(search, this);
            }
        },
        searchModule: debounce(function (search, vm) {
            vm.$http
                .get(
                    process.env.BARRACUDA +
                        "payment/payment-method/?entity_id=" +
                        vm.payer.id +
                        "&entityType=" +
                        vm.entity
                )
                .then(res => {
                    vm.remote_options = get(res, "data.response.resource", []);
                    return vm.remote_options;
                })
                .catch(() => {
                    vm.remote_options = [];
                })
                .finally(() => {
                    vm.$emit("options-loaded", vm.remote_options);
                    vm.loading = false;
                    if (vm.search_text.length < 2) {
                        vm.remote_options = [];
                    }
                });
        }, 350),
        onChange(value) {
            this.searchModule("", this);
            value.label = value.payment_method_name;
        },
        // Defocus will lost the current text, save it to somewhere else.
        setSearchText(event) {
            this.txt = this.search_text;
            this.$emit("search:blur", event);
        },
        addPaymentMethod() {
            this.$refs.newPaymentMethodWindow.open({
                name: this.search_text,
                client: this.payer,
                is_first_time: this.remote_options.length === 0,
                is_extension: this.isExtension,
                cc_processor: this.ccProcessor,
                entity: this.entity
            });
            this.preventFocus();
        },
        preventFocus() {
            let self = this;
            this.$root.$once("bv::modal::hidden", () => {
                self.$nextTick(() => {
                    self.$nextTick(() => {
                        $(self.$refs.vselect.$el).find("input").blur();
                    });
                });
            });
        }
    }
};
</script>
